var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tariff-card',{staticClass:"free-plan",attrs:{"plan":_vm.plan,"options":_vm.options,"show-cancel-button":false},on:{"sign-up":_vm.onSignUp},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('span',{staticClass:"label-free"},[_vm._v(_vm._s(_vm.$t('pagePlans.free')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }